import { Button, cn } from "../ui";

export interface UpdateBannerProps {
  placement: "top" | "bottom";
  onLater: () => void;
  onReload: () => void;
}

/** The "New version available" banner the service worker prompt shows. */
export function UpdateBanner({ placement, onLater, onReload }: UpdateBannerProps) {
  return (
    <div
      role="status"
      className={cn(
        "fixed inset-x-3 z-50 mx-auto flex max-w-md items-center gap-3 rounded-[14px] border border-line bg-surface p-3 shadow-soft",
        // Quick Add's keypad fills the bottom of the screen, so there the prompt sits on top.
        placement === "top" ? "top-[calc(env(safe-area-inset-top)+12px)]" : "bottom-24 md:bottom-6",
      )}
    >
      <span className="flex-1 text-[14.5px] font-semibold">New version available</span>
      <Button variant="ghost" size="sm" onClick={onLater}>
        Later
      </Button>
      <Button variant="primary" size="sm" onClick={onReload}>
        Reload
      </Button>
    </div>
  );
}
